// extracted by mini-css-extract-plugin
module.exports = {"network":"style_network__CWgvr","network-status":"style_network-status__0MJe1","network-text":"style_network-text__3EToY"};